/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 42,
  image: "default-changelog-v2.png",
  title: "Public Community Feature, Compute Shell, Node Version 18 LTS, Platform improvements & Fixes",
  shortDescription: "We have released a new Public Community Feature. Added support for deploying projects on Node Version 18 and executing commands on Cluster Includes. The new version also includes various platform improvements and fixes.",
  description: "We have released a new Public Community Feature. Added support for deploying projects on Node Version 18 and executing commands on Cluster Includes. The new version also includes various platform improvements and fixes.",
  date: "Aug 21st, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `

## Public Community Feature Release

We are pleased to announce a new feature that allows organizations to opt for public accessibility. This feature provides the following benefits:

- Organization owners can make their entities visible to external users.
- External users are permitted to contribute financially to the organization by linking their cryptocurrency wallets.
- Increased transparency, collaboration, and community support.
- Authorized external users gain read-only access to essential information like project deployment specifications, domain data, and comprehensive organizational details, ensuring data security.
- This advancement aligns with our vision of supporting Decentralized Autonomous Organization (DAO) principles, emphasizing decentralized governance and empowering the community.

## Introducing Node Version 18 LTS

We now support the deployment of projects built on Node.js version 18. This integration:

- Offers the advantages of the latest features, optimizations, and enhancements found in Node.js version 18.
- Ensures compatibility with contemporary Node.js features, thereby boosting software efficacy, security, and the end-user experience.

## Compute Shell Functionality

Introducing a feature that facilitates the execution of commands on your Cluster Instance. To utilize:

- Proceed to the Shell tab found on your Instance's Logs page and initiate your desired commands.

## Platform Enhancements & Fixes

### Billing Updates:

- The Pro plan now supports up to 3 free members, an increase from the previous single free member, enhancing collaboration opportunities.
- Users can now acquire compute credits within the Default Subscription Plan, optimizing the acquisition process and ensuring timely resource availability.
- Improved Invoice Details: Invoices now encompass the specific payment method used for transactions.

### Compute User Experience:

- We've heeded your feedback and made several improvements:
  - Enhanced user experience (UX) designs.
  - Resolved prevalent issues.
  - Updated and refined labels and workflow.
- The cumulative impact of these changes is a more streamlined and intuitive compute experience, simplifying resource management for our users.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
